module.exports = __webpack_public_path__ + "static/claire-088f3d5d7a7df925e853f22df9ca1ab8.jpg";